import { useReduxState } from 'hooks';
import { UserAttributesConditionsManager } from 'components/admin/settings/userAttributes';
import {
  Checkbox,
  FormGroup,
  FormSection,
  UserSummaryEmailConfiguration
} from 'components/common/form';
import { SiteSettingsForm } from '.';

const SiteSettingsUsers = () => {
  const { messages, serverConfig } = useReduxState();

  const {
    profileSummaryEmailEnabled,
    profileSummaryEmailFrequency,
    profileSummaryEmailOptions,
    userEnableOtherProfiles
  } = serverConfig;

  const availableAttributes = {};
  serverConfig.userCustomAttributes.forEach((availableAttribute) => {
    availableAttributes[availableAttribute.key] = availableAttribute;
  });

  const summaryOptions = [
    {
      label: messages.profileSummaryEmailCoursesAddedTo,
      value: 'coursesAddedTo'
    },
    {
      label: messages.profileSummaryEmailLearningPathsAddedTo,
      value: 'learningPathsAddedTo'
    },
    {
      label: messages.profileSummaryEmailAchievementsAddedTo,
      value: 'achievementsAddedTo'
    },
    {
      label: messages.profileSummaryEmailCalendarEventsAddedTo,
      value: 'calendarEventsAddedTo'
    },
    {
      label: messages.commonUpcomingTargetSchedules,
      value: 'upcomingDeadlines'
    },
    {
      label: messages.completionsExpiring,
      value: 'expiringCompletions'
    },
    {
      label: messages.completionsExpired,
      value: 'expiredCompletions'
    },
    {
      label: messages.tasksOpenQuestionAnswerReviews,
      value: 'openQuestionAnswerReviews'
    }
  ];

  const initialValues = {
    profileSummaryEmailEnabled,
    profileSummaryEmailFrequency,
    profileSummaryEmailOptions,
    userEnableOtherProfiles
  };

  return (
    <div className="settings-users">
      <SiteSettingsForm<typeof initialValues>
        initialValues={initialValues}
        padding={0}
        title={messages.commonUsers}
      >
        {(formState) => (
          <div>
            <UserSummaryEmailConfiguration
              isSiteSettingsView={true}
              summaryOptions={summaryOptions}
            />

            <FormSection maxWidth="100%">
              <FormGroup
                htmlFor="settings-users-other-profiles"
                label="Other profiles"
                maxWidth="100%"
              >
                <Checkbox
                  field="userEnableOtherProfiles.isEnabled"
                  id="user-enable-other-profiles-enabled"
                  label={'Enable users to see other profiles'}
                />
                {formState?.values?.userEnableOtherProfiles?.isEnabled && (
                  <UserAttributesConditionsManager
                    availableAttributes={availableAttributes}
                    fieldPrefix="userEnableOtherProfiles"
                    includeAuthenticationTypeCondition={true}
                    includeEmailCondition={true}
                    includeEmailDomainCondition={true}
                    includeIsSelfRegisteredCondition={true}
                  />
                )}
              </FormGroup>

              {formState?.values?.userEnableOtherProfiles?.isEnabled && (
                <FormGroup
                  htmlFor="settings-users-competency-endorsements"
                  label="Competency endorsements"
                >
                  <Checkbox
                    disabled={
                      !formState?.values?.userEnableOtherProfiles?.isEnabled
                    }
                    field="userEnableOtherProfiles.enableCompetencyEndorsements"
                    id="user-enable-other-profiles-competency-endorsements"
                    label={'Enable competency endorsements'}
                  />
                </FormGroup>
              )}
            </FormSection>
          </div>
        )}
      </SiteSettingsForm>
    </div>
  );
};

export default SiteSettingsUsers;
